import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`cab`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`cab`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`cab`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`cab/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`cab/transfer`, data);
  return response
}

export const passwordValidation = async (data) => {
  const response = await instance.post(`cab/password`, data);
  return response
}